import join from 'url-join'

import config from '../config.js'
import { MentionResource } from '../util/MentionResource'

const api = join.bind(null, config.apiUrl)

const Provider = (issueKey) => new MentionResource({
    url: api('/ssp/mention'),
    issueKey: issueKey,
    // securityProvider: () => {
    //     return {
    //         headers: {
    //             ...getGlobalHeader(),
    //             'Access-Control-Allow-Credentials': true
    //         }
    //     };
    //   },
})

const mentionProvider = (issueKey) =>Promise.resolve(Provider(issueKey))

export default mentionProvider


// WEBPACK FOOTER //
// ./client/src/components/MentionProvider.js